export default function NotFoundPage() {
  return (
    <main className="container">
      <h1>Page not found</h1>
      <p>
        If you scanned a QR code at a venue, try scanning it again. Otherwise check the link and try
        once more.
      </p>
    </main>
  );
}
